import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';

const FooterLinks = () => {
  const { t } = useTranslatedContent('footer');

  const links = [
    { href: '#home', label: t('quickLinks.links.home') },
    { href: '#solutions', label: t('quickLinks.links.solutions') },
    { href: '#services', label: t('quickLinks.links.services') },
    { href: '#training', label: t('quickLinks.links.training') },
    { href: '#cloud', label: t('quickLinks.links.cloud') },
    { href: '#support', label: t('quickLinks.links.support') },
    { href: '#meeting', label: t('quickLinks.links.meeting') },
    { href: '#whatsnew', label: t('quickLinks.links.news') },
    { href: '/legal', label: t('quickLinks.links.legal') }
  ];

  return (
    <div>
      <h3 className="text-lg font-semibold text-white mb-4">{t('quickLinks.title')}</h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.href}>
            <a 
              href={link.href} 
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinks;